module.exports = __webpack_public_path__ + "img/ihale_logo.6394164d.svg";